export const translations = {
  en: {
    nav: {
      services: "Services",
      philosophy: "Philosophy",
      successStories: "Success Stories",
      about: "About",
      contact: "Contact"
    },
    header: {
      title: "Transform Your Health Journey",
      subtitle: "Professional nutrition consulting for a healthier, happier you",
      cta: "Get Started"
    },
    services: {
      title: "How I Can Help You",
      intro1: "Want to feel better in your body, regain your energy and achieve your physical goals without going to extremes?",
      intro2: "I offer complete and personalized support in nutrition and sports, which respects your pace and adapts to your daily life.",
      customMealPlans: {
        title: "Custom Meal Plans",
        description: "According to your metabolism, your habits, your goals."
      },
      personalGroupCoaching: {
        title: "Individual or Group Sports Coaching",
        description: "Strength, mobility, weight loss, fitness..."
      },
      weeklyFollowUp: {
        title: "Weekly Follow-up",
        description: "assessment, photos, weight, feelings..."
      },
      unlimitedSupport: {
        title: "Unlimited Support",
        description: "via WhatsApp or call every week"
      },
      workshops: {
        title: "Nutrition & Wellness Workshops",
        description: "to go further together"
      }
    },
    philosophy: {
      title: "My Approach to Fitness",
      personalizedTraining: {
        title: "Personalized Training",
        description: "I believe in creating workout plans that are specifically designed for your body, goals, and lifestyle. No two clients are the same, and neither should their training programs be."
      },
      balancedLifestyle: {
        title: "Balanced Lifestyle",
        description: "Fitness isn't just about the time you spend in the gym. I help you develop sustainable habits that fit into your daily life, making health and wellness a natural part of your routine."
      },
      scienceBased: {
        title: "Science-Based Methods",
        description: "My training methods are grounded in the latest exercise science and research. I combine proven techniques with practical experience to ensure you get the best results."
      },
      longTermSuccess: {
        title: "Long-Term Success",
        description: "I focus on helping you build a strong foundation of fitness knowledge and habits that will serve you for life, not just quick fixes or temporary solutions."
      }
    },
    successStories: {
      title: "Success Stories",
      sarah: {
        name: "Sarah's Journey",
        quote: "After struggling with energy levels for years, the personalized nutrition plan helped me regain my vitality. I've lost 15kg and feel better than ever!",
        stat1: "Weight Loss: 15kg",
        stat2: "Duration: 6 months"
      },
      michael: {
        name: "Michael's Transformation",
        quote: "The holistic approach helped me manage my diabetes better. My blood sugar levels are now stable, and I've reduced my medication by 50%.",
        stat1: "Blood Sugar: -30%",
        stat2: "Duration: 8 months"
      },
      emma: {
        name: "Emma's Success",
        quote: "The sustainable approach to nutrition helped me develop a healthy relationship with food. I've maintained my weight for over a year now!",
        stat1: "Maintained: 12+ months",
        stat2: "Duration: Ongoing"
      }
    },
    about: {
      title: "About Me",
      subtitle: "Your Personal Trainer & Nutrition Coach",
      paragraph1: "I'm passionate about helping you achieve your fitness and health goals through a combination of personalized training and nutrition guidance. As a certified personal trainer and nutrition specialist, I understand that true transformation comes from both physical activity and proper nutrition.",
      paragraph2: "With years of experience in the fitness industry, I've helped countless clients transform their bodies and improve their overall health. My approach combines effective workout routines with practical nutrition advice, creating sustainable habits that fit your lifestyle. Whether you're looking to build strength, lose weight, or improve your overall fitness, I'm here to guide and motivate you every step of the way.",
      stats: {
        clients: "Clients Trained",
        experience: "Years Experience",
        satisfaction: "Client Satisfaction"
      }
    },
    contact: {
      title: "Get in Touch",
      email: "Email:",
      phone: "Phone:",
      address: "Address:",
      form: {
        name: "Your Name",
        email: "Your Email",
        message: "Your Message",
        submit: "Send Message"
      }
    },
    footer: {
      copyright: "© 2024 NutriFit Consulting. All rights reserved."
    }
  },
  fr: {
    nav: {
      services: "Services",
      philosophy: "Philosophie",
      successStories: "Succès",
      about: "À propos",
      contact: "Contact"
    },
    header: {
      title: "Transformez Votre Parcours Santé",
      subtitle: "Consultation nutritionnelle professionnelle pour une vie plus saine et plus heureuse",
      cta: "Commencer"
    },
    services: {
      title: "Comment puis-je t'aider ?",
      intro1: "Tu veux te sentir mieux dans ton corps, retrouver ton énergie et atteindre tes objectifs physiques sans tomber dans l'extrême ?",
      intro2: "Je propose un accompagnement complet et personnalisé en nutrition et en sport, qui respecte ton rythme et s'adapte à ton quotidien.",
      customMealPlans: {
        title: "Programmes alimentaires sur mesure",
        description: "Selon ton métabolisme, tes habitudes, tes objectifs."
      },
      personalGroupCoaching: {
        title: "Coaching sportif individuel ou en groupe",
        description: "Force, mobilité, perte de poids, remise en forme…"
      },
      weeklyFollowUp: {
        title: "Suivi hebdomadaire",
        description: "bilan, photos, poids, ressentis…"
      },
      unlimitedSupport: {
        title: "Support illimité",
        description: "via WhatsApp ou appel chaque semaine"
      },
      workshops: {
        title: "Ateliers nutrition & bien-être",
        description: "pour aller plus loin ensemble"
      }
    },
    philosophy: {
      title: "Mon Approche du Fitness",
      personalizedTraining: {
        title: "Entraînement Personnalisé",
        description: "Je crois en la création de programmes d'entraînement spécifiquement conçus pour votre corps, vos objectifs et votre mode de vie. Aucun client n'est identique, et leurs programmes d'entraînement ne devraient pas l'être non plus."
      },
      balancedLifestyle: {
        title: "Mode de Vie Équilibré",
        description: "Le fitness ne se limite pas au temps passé en salle de sport. Je vous aide à développer des habitudes durables qui s'intègrent à votre vie quotidienne, faisant de la santé et du bien-être une partie naturelle de votre routine."
      },
      scienceBased: {
        title: "Méthodes Scientifiques",
        description: "Mes méthodes d'entraînement sont basées sur les dernières recherches en science de l'exercice. Je combine des techniques éprouvées avec une expérience pratique pour vous garantir les meilleurs résultats."
      },
      longTermSuccess: {
        title: "Succès à Long Terme",
        description: "Je me concentre sur l'aide à la construction d'une solide base de connaissances en fitness et d'habitudes qui vous serviront toute la vie, pas seulement des solutions rapides ou temporaires."
      }
    },
    successStories: {
      title: "Succès",
      sarah: {
        name: "Le Parcours de Sarah",
        quote: "Après avoir lutté avec mes niveaux d'énergie pendant des années, le plan nutritionnel personnalisé m'a aidée à retrouver ma vitalité. J'ai perdu 15kg et je me sens mieux que jamais !",
        stat1: "Perte de poids : 15kg",
        stat2: "Durée : 6 mois"
      },
      michael: {
        name: "La Transformation de Michael",
        quote: "L'approche holistique m'a aidé à mieux gérer mon diabète. Mes niveaux de glycémie sont maintenant stables, et j'ai réduit mes médicaments de 50%.",
        stat1: "Glycémie : -30%",
        stat2: "Durée : 8 mois"
      },
      emma: {
        name: "Le Succès d'Emma",
        quote: "L'approche durable de la nutrition m'a aidée à développer une relation saine avec la nourriture. Je maintiens mon poids depuis plus d'un an maintenant !",
        stat1: "Maintenu : 12+ mois",
        stat2: "Durée : En cours"
      }
    },
    about: {
      title: "À propos",
      subtitle: "Votre Entraîneur Personnel & Coach Nutrition",
      paragraph1: "Je suis passionnée par l'aide à atteindre vos objectifs de fitness et de santé grâce à une combinaison d'entraînement personnalisé et de conseils nutritionnels. En tant qu'entraîneuse personnelle certifiée et spécialiste en nutrition, je comprends que la vraie transformation vient à la fois de l'activité physique et d'une nutrition appropriée.",
      paragraph2: "Avec des années d'expérience dans l'industrie du fitness, j'ai aidé d'innombrables clients à transformer leur corps et à améliorer leur santé globale. Mon approche combine des routines d'entraînement efficaces avec des conseils nutritionnels pratiques, créant des habitudes durables qui s'adaptent à votre mode de vie. Que vous cherchiez à développer votre force, à perdre du poids ou à améliorer votre condition physique globale, je suis là pour vous guider et vous motiver à chaque étape.",
      stats: {
        clients: "Clients Entraînés",
        experience: "Années d'Expérience",
        satisfaction: "Satisfaction Client"
      }
    },
    contact: {
      title: "Contactez-moi",
      email: "Email :",
      phone: "Téléphone :",
      address: "Adresse :",
      form: {
        name: "Votre Nom",
        email: "Votre Email",
        message: "Votre Message",
        submit: "Envoyer le Message"
      }
    },
    footer: {
      copyright: "© 2024 NutriFit Consulting. Tous droits réservés."
    }
  },
  nl: {
    nav: {
      services: "Diensten",
      philosophy: "Filosofie",
      successStories: "Succesverhalen",
      about: "Over Mij",
      contact: "Contact"
    },
    header: {
      title: "Transformeer Uw Gezondheidsreis",
      subtitle: "Professionele voedingsconsulting voor een gezonder en gelukkiger leven",
      cta: "Start Nu"
    },
    services: {
      title: "Hoe Kan Ik U Helpen?",
      intro1: "Wil je je beter voelen in je lichaam, je energie terugkrijgen en je fysieke doelen bereiken zonder in extremen te vervallen?",
      intro2: "Ik bied complete en gepersonaliseerde begeleiding in voeding en sport, die jouw tempo respecteert en zich aanpast aan jouw dagelijks leven.",
      customMealPlans: {
        title: "Op Maat Gemaakte Maaltijdplannen",
        description: "Volgens jouw metabolisme, jouw gewoonten, jouw doelen."
      },
      personalGroupCoaching: {
        title: "Individuele of Groepssport Coaching",
        description: "Kracht, mobiliteit, gewichtsverlies, fitness..."
      },
      weeklyFollowUp: {
        title: "Wekelijkse Opvolging",
        description: "evaluatie, foto's, gewicht, gevoelens..."
      },
      unlimitedSupport: {
        title: "Onbeperkte Ondersteuning",
        description: "via WhatsApp of bel elke week"
      },
      workshops: {
        title: "Voeding & Welzijn Workshops",
        description: "om samen verder te gaan"
      }
    },
    philosophy: {
      title: "Mijn Aanpak van Fitness",
      personalizedTraining: {
        title: "Gepersonaliseerde Training",
        description: "Ik geloof in het maken van trainingsprogramma's die specifiek zijn ontworpen voor uw lichaam, doelen en levensstijl. Geen twee cliënten zijn hetzelfde, en hun trainingsprogramma's zouden dat ook niet moeten zijn."
      },
      balancedLifestyle: {
        title: "Gebalanceerde Levensstijl",
        description: "Fitness draait niet alleen om de tijd die u in de sportschool doorbrengt. Ik help u duurzame gewoonten te ontwikkelen die passen bij uw dagelijks leven, waardoor gezondheid en welzijn een natuurlijk onderdeel worden van uw routine."
      },
      scienceBased: {
        title: "Wetenschappelijke Methoden",
        description: "Mijn trainingsmethoden zijn gebaseerd op de nieuwste bewegingswetenschap en onderzoek. Ik combineer bewezen technieken met praktische ervaring om u de beste resultaten te garanderen."
      },
      longTermSuccess: {
        title: "Lange Termijn Succes",
        description: "Ik focus op het helpen opbouwen van een sterke basis van fitnesskennis en gewoonten die u een leven lang zullen dienen, niet alleen snelle oplossingen of tijdelijke oplossingen."
      }
    },
    successStories: {
      title: "Succesverhalen",
      sarah: {
        name: "Sarah's Reis",
        quote: "Na jarenlang te worstelen met energieniveaus, hielp het gepersonaliseerde voedingsplan me mijn vitaliteit terug te krijgen. Ik ben 15kg kwijtgeraakt en voel me beter dan ooit!",
        stat1: "Gewichtsverlies: 15kg",
        stat2: "Duur: 6 maanden"
      },
      michael: {
        name: "Michael's Transformatie",
        quote: "De holistische aanpak hielp me mijn diabetes beter te beheren. Mijn bloedsuikerspiegels zijn nu stabiel en ik heb mijn medicatie met 50% verminderd.",
        stat1: "Bloedsuiker: -30%",
        stat2: "Duur: 8 maanden"
      },
      emma: {
        name: "Emma's Succes",
        quote: "De duurzame aanpak van voeding hielp me een gezonde relatie met voedsel te ontwikkelen. Ik heb mijn gewicht nu al meer dan een jaar behouden!",
        stat1: "Behouden: 12+ maanden",
        stat2: "Duur: Lopend"
      }
    },
    about: {
      title: "Over Mij",
      subtitle: "Uw Persoonlijke Trainer & Voedingscoach",
      paragraph1: "Ik ben gepassioneerd door het helpen van u om uw fitness- en gezondheidsdoelen te bereiken door een combinatie van gepersonaliseerde training en voedingsbegeleiding. Als gecertificeerde personal trainer en voedingsspecialist begrijp ik dat echte transformatie komt van zowel fysieke activiteit als goede voeding.",
      paragraph2: "Met jarenlange ervaring in de fitnessindustrie heb ik talloze cliënten geholpen hun lichaam te transformeren en hun algehele gezondheid te verbeteren. Mijn aanpak combineert effectieve trainingsroutines met praktisch voedingsadvies, waardoor duurzame gewoonten ontstaan die bij uw levensstijl passen. Of u nu kracht wilt opbouwen, gewicht wilt verliezen of uw algehele conditie wilt verbeteren, ik ben er om u elke stap van de weg te begeleiden en te motiveren.",
      stats: {
        clients: "Getrainde Cliënten",
        experience: "Jaar Ervaring",
        satisfaction: "Cliënttevredenheid"
      }
    },
    contact: {
      title: "Neem Contact Op",
      email: "Email:",
      phone: "Telefoon:",
      address: "Adres:",
      form: {
        name: "Uw Naam",
        email: "Uw Email",
        message: "Uw Bericht",
        submit: "Bericht Verzenden"
      }
    },
    footer: {
      copyright: "© 2024 NutriFit Consulting. Alle rechten voorbehouden."
    }
  }
}; 